import type { TreatmentPageSection } from '@components/app/TreatmentPage/TableOfContents'
import { Text } from '@components/primitives/Text'
import type { ReactNode } from 'react'
import type { InViewHookResponse } from 'react-intersection-observer'
import type { ListingPageNavbarSections } from '../NavbarTableOfContents'

export type ListingSection =
  | 'design'
  | 'effectiveness'
  | 'studyObjectives'
  | 'eligibilityCriteria'
  | 'faq'
  | 'logistics'
  | 'relatedTrials'
  | 'safety'
  | 'summary'
  | 'research'
  | 'researchFindings'

export const ListingSection = ({
  children,
  hide = false,
  id,
  innerRef,
  title,
}: {
  children?: ReactNode
  hide?: boolean
  id: ListingSection | TreatmentPageSection | ListingPageNavbarSections
  innerRef?: InViewHookResponse['ref']
  title?: string
}) => {
  if (hide || !children) {
    return null
  }
  return (
    <section aria-label={title ?? id} id={id} ref={innerRef}>
      <Text
        className='mb-2 text-neutral900 lg:mb-4'
        element={'h3'}
        styleName='h4'
        value={title}
      />

      {children}
    </section>
  )
}
